<template lang="pug">
  
  div
    MHeader(
      page-title="Your Results"
      v-bind:breadcrumbs="breadcrumbs"
    )
    div( class="wrapper wrapper-content" )
      div( class="row d-none" )
        div( class="col-lg-3" )
          MWidget( class="report-widget info" label="Links Checked" v-bind:focus="`${linksChecked}`" )
        div( class="col-lg-3" )
          MWidget( class="report-widget success" label="Passed" v-bind:focus="`${linksPassed}`" )
        div( class="col-lg-3" )
          MWidget( class="report-widget danger" label="Failed" v-bind:focus="`${linksFailed}`" )
        div( class="col-lg-3" )
          MWidget( class="report-widget" label="Last Checked" v-bind:focus="`null`" )

      div( class="row" )
        div( class="col-6 d-flex align-items-end" )
          button( class="btn btn-link" v-on:click="toggleBin" v-if="$moonpull.currentUserIsSuperAdmin()" )
            span( v-if="! viewBin" )
              i( class="fa fa-trash" )
              | &nbsp;View deleted batches
            span( v-else )
              i( class="fa fa-caret-left" )
              | &nbsp;Back to batches

        div( class="col-6 text-right" )
          p Page {{ page }} of {{ lastPageNum }}
          span Per page:&nbsp;
          select( v-model="pageSize" class="btn btn-default dropdown-toggle" )
            option( class="dropdown-menu show" value="10" ) 10
            option( class="dropdown-menu show" value="25" ) 25
            option( class="dropdown-menu show" value="50" ) 50
            option( class="dropdown-menu show" value="100" ) 100
          | &nbsp;
          div( class="btn-group" )
            button( class="btn btn-white" v-bind:disabled="page === 1" v-on:click="() => page -= 1" ) Prev page
            button( class="btn btn-white" v-bind:disabled="page === lastPageNum" v-on:click="() => page += 1" ) Next page
      
      div( class="ibox mt-2" )
          div( class="ibox-title filter-title-bar" v-on:click.prevent="showFilter = ! showFilter" )
            strong Advanced search
            div( class="ibox-tools" )
              a( class="collapse-link" href="#" v-on:click.prevent="" )
                i( class="fa" v-bind:class="{ 'fa-chevron-up': showFilter, 'fa-chevron-down': ! showFilter }" )

          div( class="ibox-content" v-bind:class="{ 'd-none': ! showFilter }" )

            div( class="row" )
              div( class="col-12" )
                label Min links (zero for no limit):
                input( class="form-control" type="number" min="0" v-model="minLinksPerBatch" )
            
            div( class="row mt-4" )
              div( class="col-12" )
                label Filter results by name, batch id, description or user
                div( class="input-group" )
                  div( class="input-group-prepend" )
                    span( class="input-group-addon" )
                      i( class="fa fa-search" )
                  input( class="form-control" type="text" v-model="batchFilterString" )

            div( class="row mt-4" v-if="$moonpull.currentUserIsSuperAdmin()" )
              div( class="col-3" )
                MMoonpullIcon( class="mr-2")
                | Select batch size:
                br
                button(
                  v-for="option in linkFilterOptions"
                  :class="['btn', selectedLinkFilter === option.value ? 'btn-primary' : 'btn-white']"
                  v-on:click="handleClick(option.value)"
                ) {{ option.label }}

              div(class="col-sm-2")
                MMoonpullIcon( class="mr-2" )
                label Select audits before:
                input( type="date" placeholder="Start date" class="form-control" v-model="endDate" )

              div( class="col-sm-4" )
                MMoonpullIcon( class="mr-2" )
                label Select Company Type:
                br
                select( v-model="selectedCompanyType" class="btn btn-default btn-xs dropdown-toggle" )
                  option( class="dropdown-menu show" value="" ) All
                  option( class="dropdown-menu show" value="MOONPULL" ) Moonpull
                  option( class="dropdown-menu show" value="ALL_EXCEPT_MOONPULL" ) All except Moonpull
                  option( class="dropdown-menu show" value="NETWORK" ) Network
                  option( class="dropdown-menu show" value="ADVERTISER" ) Advertiser
                  option( class="dropdown-menu show" value="PUBLISHER" ) Publisher
                  option( class="dropdown-menu show" value="AGENCY" ) Agency
                  option( class="dropdown-menu show" value="EARLY_ADOPTER" ) Early Adopter
              
              div( class="col-12 mt-2" )
                MMoonpullIcon( class="mr-2" )
                label Select CS Status:
                select( class="form-control" v-model="selectedCsStatus" )
                  option( v-bind:value="null" ) All
                  option( value="danger" ) Danger
                  option( value="warning" ) Warning
                  option( value="success" ) Success
      

      
      div( class="mb-2" v-bind:class="{ 'border border-danger': viewBin }" )
        strong( v-if="viewBin" class="text-danger" ) Currently viewing deleted batches
        MRefreshQueryButton( v-bind:apollo-query="$apollo.queries.batches" )
      div( class="ibox mb-2" )
        div( class="ibox-title" )
          div( class="row" )
            div( class="col-sm-4" ) Name / Description
            div( class="col-sm-2" ) Run By
            div( class="col-sm-1" ) Links
            div( class="col-sm-1" ) Started At
            div( class="col-sm-2" ) Status
            div( class="col-sm-2" ) Actions

      div(
        v-for="batch in filteredBatches"
        :key="batch.id"
        class="ibox my-0"
        style="word-break: break-word;"
      )
        div(
          class="ibox-title cursor-pointer border"
          v-on:click="toggleRow(batch.id)"
        )
          div(class="row")
            div( class="col-sm-4" )
              strong {{ batch.name }}
              br
              em {{ batch.description }}
              br
              div( v-if="batch.atlasId" )
                strong Atlas ID:&nbsp;
                code {{ batch.atlasId }}
            div(class="col-sm-2")
              | {{ batch.owner.email }}
              br
              span(v-if="batch.owner.company") {{ batch.owner.company.name }}
            div(class="col-sm-1")
              | {{ batch.numCurrentCompletedAudits }}
              br
              em ({{ batch.numLinks }})
            div(class="col-sm-1")
              span.text-muted {{ dateFormat(batch.startedAt, 'dd/mm/yy') }}
              br
              span.text-muted {{ dateFormat(batch.startedAt, 'HH:MM Z') }}
            div(class="col-sm-2")
              span(class="badge badge-primary" v-if="batch.isDone") Done
              span(class="badge" v-else)
                i(class="fa fa-spinner fa-spin mr-2")
                | Processing {{ batch.numCurrentCompletedAudits }} / {{ batch.numLinks }} links...
              br
              span(class="badge badge-danger mt-2 d-inline-block" v-if="$moonpull.currentUserIsSuperAdmin() && batch.hasDuplicates")
                MMoonpullIcon(class="mr-2")
                | Requires Cleanup
              div( v-if="$moonpull.currentUserIsSuperAdmin()" )
                span 
                | {{ readableCsStatus[batch.csStatus] }}
                br
                span(v-if="batch.csComment") {{ batch.csComment }}

            div(class="col-sm-2")
              div( class="btn-group" )
                router-link(
                  class="btn btn-details btn-outline btn-info no-wrap-link"
                  v-bind:to="(batch.atlasId) ? $moonpull.nuxtUrl(`/reporting/batches/${batch.atlasId}`) : `/reporting/memory/cookie/${batch.id}`"
                ) View Batch
                div( v-if="! batch.atlasId" ) 
                  button( class="btn btn-details btn-outline btn-info" v-on:click.stop="toggleDropdown(batch.id)" v-if="! batch.atlasId" )
                    i( class="fa fa-caret-down" )
                  ul(
                    class="batch-options-dropdown dropdown-menu"
                    v-bind:class="{ 'show': batch.dropdownToggle }"
                    v-on:click.stop
                    x-placement="bottom-start"
                  )
                    li
                      MModalButton( button-classes="dropdown-item m-0 dropdown-font-style" modal-size="modal-lg" v-bind:title="`Rename batch \"${batch.name}\"`" )
                        span( slot="button-inner" ) Rename
                        div( slot="body" class="text-left font-normal" )
                          p
                            label( for="new-batch-name" ) New name for batch:
                            input( class="form-control" id="new-batch-name" name="new-batch-name" v-model="newBatchName" )
                          p
                            label( for="new-batch-description" ) New description for batch:
                            input( class="form-control" id="new-batch-description" name="new-batch-description" v-model="newBatchDescription" )
                        p( slot="footer" class="text-right font-normal" )
                          button( class="btn btn-primary" v-on:click="renameBatch(batch.id)" v-bind:disabled="innerModalLoading" )
                            i( v-if="innerModalLoading" class="mr-2" )
                            | Rename
                    li
                      a(
                        class="dropdown-item w-100 m-0"
                        href="#"
                        v-on:click.prevent="copyToClipboard(batch.id)"
                      )
                        i()
                        | Copy Batch ID
                    li
                      a(
                        class="dropdown-item w-100 m-0"
                        href="#"
                        v-if="$moonpull.currentUserHasAccessTo('enterpriseReportAccess')"
                        v-on:click.prevent="generateCSV(batch.id)"
                      )
                        i()
                        | Download Enterprise Report
                    li
                      a(
                        class="dropdown-item w-100 m-0"
                        href="#"
                        v-on:click.prevent="generateClientReportCSV(batch.id)"
                      )
                        i()
                        | Download Publisher Report
                    li 
                      a(
                        class="dropdown-item w-100 m-0"
                        href="#"
                        v-if="$moonpull.currentUserHasAccessTo('publisherReportWithAdvertiser')"
                        v-on:click.prevent="generatePublisherReportCSV(batch.id)"
                      )
                        i()
                        | Download Publisher Report with advertiser history

                    li(v-if="$moonpull.currentUserIsSuperAdmin()" )
                      MModalButton( button-classes="dropdown-item m-0" modal-size="modal-lg" v-bind:title="`Change owner for \"${batch.name}\"`" )
                        span( slot="button-inner" )
                          MMoonpullIcon( class="mr-2" )
                          | Change Owner
                        p( slot="body" class="text-left font-normal" )
                          MUserSelector( v-model="newBatchOwnerId" )
                        p( slot="body" class="text-left font-normal" )
                          label
                            input( class="mr-2" type="checkbox" v-model="deleteComparisonsOnChangeOwner" )
                            | Delete audit comparisons when changing owner?
                        p( slot="footer" class="text-right font-normal" )
                          button( class="btn btn-primary" v-on:click="changeOwner(batch.id)" v-bind:disabled="innerModalLoading" )
                            MLoadingSpinner( v-if="innerModalLoading" class="mr-2" )
                            | Change Owner
                    li( v-if="$moonpull.currentUserIsSuperAdmin() && batch.isDone" )
                      a(
                        class="dropdown-ite w-100 m-0"
                        href="#"
                        v-on:click.prevent="downloadCSV(batch.id)"
                        v-bind:disabled="csvIsDownloading"
                      )
                        MMoonpullIcon
                        span( v-if="csvIsDownloading" )
                          i( class="fa fa-spinner fa-spin mr-2" )
                        | &nbsp;Export
                    li( v-if="$moonpull.currentUserIsSuperAdmin() && ! batch.finishedAt" )
                      a( class="dropdown-item w-100 m-0" href="#" v-on:click.prevent="markBatchAsComplete(batch.id)" v-bind:disabled="updatingBatch" )
                        span( v-if="updatingBatch" )
                          i( class="fa fa-spinner fa-spin mr-2" )
                        MMoonpullIcon
                        | &nbsp;Mark as complete
                    li( v-if="$moonpull.currentUserIsSuperAdmin() && ! batch.deletedAt" )
                      a( class="dropdown-item w-100 m-0" href="#" v-on:click.prevent="softDeleteBatch(batch.id)" v-bind:disabled="deletingBatch" )
                        span( v-if="deletingBatch" )
                          i( class="fa fa-spinner fa-spin mr-2" )
                        MMoonpullIcon
                        | &nbsp;Delete Batch
                    li( v-if="$moonpull.currentUserIsSuperAdmin()" )
                      a( class="dropdown-item w-100 m-0" href="#" v-on:click.prevent="restoreBatch(batch.id)" v-bind:disabled="restoringBatch" )
                        MLoadingSpinner( v-if="restoringBatch" )
                        MMoonpullIcon
                        | &nbsp;Restore Batch
        div(
          v-if="batch.dropdownRow"
          class="ibox-content bg-light p-3"
          v-on:click.stop
        )
          div(class="row")
            div(class="col-sm-3")
              MMemoryCookieStatusSummary(
                v-bind:memory-cookie-status-counts="batch.memoryCookieStatusCounts"
              )

            div(
              class="col-sm-9 text-left"
            ) 
              div( class="ibox" )
                div( class="ibox-content" )
                  div(class="row")
                    div(class="col-sm-6")
                      strong Batch ID
                      br
                      span.text-muted {{ batch.id }}
                      br
                      strong Audit Processing Time
                      br
                      span.text-muted(v-if="batch.isDone")
                        span(v-if="!batch.finishedAt || batch.finishedAt < batch.startedAt") -
                        span(v-else) {{ Math.ceil((new Date(batch.finishedAt) - new Date(batch.startedAt)) / 1000) }}s
                      span.text-muted(v-else) -
                      div( v-if="batch.numLinks === 1" )
                        div( class="row" )
                          div( class="col-sm-6" )
                            button( class="btn btn-primary" v-on:click="yourAuditNavigation(batch)" )
                              | See Advertiser Audits
                          div( class="col-sm-6" )
                            button( class="btn btn-primary" v-on:click="rerunBatch(batch.id)" )
                              | Rerun Audit
                        
                      div( v-if="! batch.atlasId" )
                        div( class="text-left mt-4" v-if="$moonpull.currentUserIsSuperAdmin() || $moonpull.currentUserHasAccessTo('cmpCounts')" )
                          div(v-if="batch.cmpTypeCountLoading")
                            | Loading...
                          div(v-else)
                            div(v-if="batch.cmpTypeCount && batch.cmpTypeCount.length" class="row")
                              div( v-for="cmpType in batch.cmpTypeCount" class="col-sm-6" )
                                MMoonpullIcon( class="mr-2" )
                                strong {{ cmpType.name}}
                                br
                                div( v-for="cmp in cmpType.counts" )
                                  span {{ cmp.cmpName }}: {{ cmp.count }}
                            div(v-else)
                              | No CMP data found.
                    div( class="col-sm-6" v-if="$moonpull.currentUserIsSuperAdmin()" )
                      strong CS Status
                      br
                      select( class="form-control" v-model="batch.csStatus" )
                        option( v-for="(label, value) in readableCsStatus" :key="value" :value="value" ) {{ label }}
                      br
                      strong CS Comment
                      br
                      input( class="form-control" v-model="batch.csComment" )
                      br
                      div( class="text-right" )
                        button( class="btn btn-primary mt-2 text-right" v-on:click="updateCsStatusAndComment(batch)" )
                          | Update
                      hr
                      p( v-if="$moonpull.currentUserIsSuperAdmin()" )
                        MModalButton(
                          title="Support Resources"
                          class="mt-2"
                          modal-size="modal-xl"
                          v-if="$moonpull.currentUserIsSuperAdmin()"
                        )
                          span( slot="button-inner" )
                            MMoonpullIcon( class="mr-1" )
                            | Support Resources
                          div( slot="body" )
                            strong Loom Video URL
                            input( class="form-control mt-2" v-model="batch.loomExternalUrl" )
                            br
                            div( v-if="$moonpull.currentUserIsSuperAdmin()" )
                              MMoonpullIcon( class="mr-2" )
                              strong Internal Loom Video URL
                              input( class="form-control mt-2" v-model="batch.loomInternalUrl" )
                            div( v-if="$moonpull.currentUserIsSuperAdmin()" )
                              MMoonpullIcon( class="mr-1" )
                              strong( class="mt-2" ) Google document URL
                              input( class="form-control mt-2" v-model="batch.googleDocUrl" )

                            button(
                              v-on:click="updateSupportResources(batch.id)"
                              class="btn btn-primary mt-2"
                            )
                              | Save Support Resources


      div( class="row" )
        div( class="col-6" )
        div( class="col-6 text-right mt-4" )
          p Page {{ page }} of {{ lastPageNum }}
          div( class="btn-group" )
            button( class="btn btn-white" v-bind:disabled="page === 1" v-on:click="() => page -= 1" ) Prev page
            button( class="btn btn-white" v-bind:disabled="page === lastPageNum" v-on:click="() => page += 1" ) Next page

</template>

<style lang="scss" scoped>
.table-list {
  width: 100%;
  word-break: normal !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  td {
    word-break: normal !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.no-break {
  word-break: normal;
}
.no-wrap-link {
  word-break: normal !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.btn-details {
  word-break: normal !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.filter-title-bar {
  cursor: pointer;
}
.batch-options-dropdown {
  left: -63px;
}
.dropdown-font-style {
  font-family: Arial, sans-serif; /* example font-family */
  font-size: 14px; /* example font-size */
}
.cursor-pointer {
  cursor: pointer;
}
</style>

<script>
import Vue from "vue";
import * as dateFormat from "dateformat";
import gql from "graphql-tag";

export default Vue.extend({
  data() {
    return {
      linksChecked: 0,
      linksPassed: 0,
      linksFailed: 0,
      batches: { items: [] },
      memoryCookieStatusCounts: [],
      lastChecked: new Date(),
      breadcrumbs: [
        { label: "Home", link: "/" },
        { label: "Reporting", link: "/reporting" },
        { label: "Your Results", link: "/reporting/batches" },
      ],
      page: 1,
      pageSize: this.$route.query.pageSize || null,
      csvIsDownloading: false,
      viewBin: false,
      deletingBatch: false,
      updatingBatch: false,
      showFilter: false,
      minLinksPerBatch: 0,
      batchFilterString: "",
      newBatchOwnerId: null,
      innerModalLoading: false,
      restoringBatch: false,
      newBatchName: "",
      newBatchDescription: "",
      linkFilterOptions: [
        { label: "All", value: "all" },
        { label: "Single", value: "single" },
        { label: "Exclude single", value: "exclude" },
        { label: "Five or more", value: "gt5" },
      ],
      selectedLinkFilter: "all",
      startDate: dateFormat(
        new Date(Date.now() - 10958 * 24 * 60 * 60 * 1000),
        "yyyy-mm-dd"
      ),
      endDate: dateFormat(
        new Date(Date.now() + 2 * 24 * 60 * 60 * 1000),
        "yyyy-mm-dd"
      ),
      selectedCompanyType: null,
      generateBatchId: "",
      deleteComparisonsOnChangeOwner: true,
      selectedCsStatus: null,
      csStatusOptions: [
        { label: "None", value: null },
        { label: "Reviewed", value: "Reviewed" },
        { label: "In Progress", value: "In Progress" },
        { label: "Not Reviewed", value: "Not Reviewed" },
      ],
      readableCsStatus: {
        reviewed: "Reviewed",
        in_progress: "In Progress",
        not_reviewed: "Not Reviewed",
      },
      showOnlyPlatformResults: false,
      currentCountry: null,
      filterString: "",
    };
  },

  watch: {
    pageSize() {
      this.page = 1;
    },
    selectedCompanyType(newVal, oldVal) {
      if (newVal) {
        // If a company type is selected
        this.pageSize = "100"; // Set the pageSize to 100 or any value you desire
      } else {
        // If company type is deselected
        this.pageSize = "10"; // Reset the pageSize to the default or any value you desire
      }
    },
  },

  apollo: {
    batches: {
      query: gql`
        query BatchPaginated(
          $page: Float!
          $pageSize: Float!
          $minNumLinks: Float!
          $batchFilterString: String
          $showDeleted: Boolean
          $startDate: DateTime!
          $endDate: DateTime!
          $csStatus: String
        ) {
          batchMany(
            page: $page
            perPage: $pageSize
            sort: { startedAt: DESC }
            filter: {
              isTemplate: false
              startedAt: { between: [$startDate, $endDate] }
              csStatus: { equals: $csStatus }
            }
            minNumLinks: $minNumLinks
            batchFilterString: $batchFilterString
            showDeleted: $showDeleted
          ) {
            count
            items {
              id
              owner {
                email
                company {
                  name
                  billingId
                  companyType
                }
              }
              name
              description
              startedAt
              finishedAt
              isDone
              deletedAt
              numLinks
              numCurrentCompletedAudits
              hasDuplicates
              csStatus
              csComment
              status
              atlasId
              loomInternalUrl
              loomExternalUrl
              googleDocUrl
            }
          }
        }
      `,
      variables() {
        return {
          page: Number(this.page),
          pageSize: Number(this.pageSize),
          showDeleted: this.viewBin,
          minNumLinks: Number(this.minLinksPerBatch),
          batchFilterString: this.batchFilterString,
          startDate: this.startDate,
          endDate: this.endDate,
          companyType: this.selectedCompanyType,
          csStatus: this.selectedCsStatus,
        };
      },
      update: (data) => {
        const batches = data.batchMany;
        batches.items.forEach((b) => {
          b.dropdownToggle = false;
        });
        return batches;
      },
      debounce: 500,
    },
  },

  computed: {
    filteredBatches() {
      // Guard against undefined batches or items
      if (!this.batches || !this.batches.items) return [];

      const companyFilter = (batch) => {
        if (!this.selectedCompanyType) return true;
        if (this.selectedCompanyType === "ALL_EXCEPT_MOONPULL") {
          return batch.owner.company.companyType !== "MOONPULL";
        }
        return batch.owner.company.companyType === this.selectedCompanyType;
      };

      const linkFilter = (batch) => {
        const minLinks = this.minLinksPerBatch;
        const selectedFilter = this.selectedLinkFilter;

        if (selectedFilter === "all") {
          return batch.numLinks >= minLinks;
        } else if (selectedFilter === "single") {
          return (
            batch.numCurrentCompletedAudits === 1 && batch.numLinks >= minLinks
          );
        } else if (selectedFilter === "exclude") {
          return (
            batch.numCurrentCompletedAudits !== 1 && batch.numLinks >= minLinks
          );
        } else if (selectedFilter === "gt5") {
          return (
            batch.numCurrentCompletedAudits >= 5 && batch.numLinks >= minLinks
          );
        }
        return true; // Default case
      };

      return this.batches.items
        .filter((batch) => companyFilter(batch) && linkFilter(batch))
        .filter((batch) => companyFilter(batch) && linkFilter(batch));
    },
    lastPageNum() {
      return this.batches
        ? Math.ceil(this.batches.count / this.pageSize)
        : "...";
    },
  },

  methods: {
    dateFormat,

    copyToClipboard(batchId) {
      navigator.clipboard
        .writeText(batchId)
        .then(() => {
          // Handle success (e.g., show a success message)
        })
        .catch((err) => {
          // Handle errors (e.g., show an error message)
          console.error("Could not copy text: ", err);
        });
    },

    async generateCSV(batchId) {
      if (!batchId) {
        console.error("No batchId provided");
        return;
      }

      console.log("batchId:", batchId);
      this.loading = true;
      analytics.track("Enterprise Report Generated", {
        batchId: this.generateBatchId,
      });
      this.generateBatchId = batchId;
      const {
        data: { generateCsvFromBatchId },
      } = await this.$apollo.query({
        query: gql`
          query GenerateCsvFromBatchId($batchId: ID!) {
            generateCsvFromBatchId(batchId: $batchId)
          }
        `,
        variables: {
          batchId,
        },
      });

      const a = document.createElement("a");
      document.body.appendChild(a);
      a.setAttribute("style", "display:none");
      const blob = new Blob([generateCsvFromBatchId], { type: "octet/stream" });
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = `batches_.csv`;
      a.click();
      window.URL.revokeObjectURL(url);

      this.loading = false;
    },

    async generateClientReportCSV(batchId) {
      if (!batchId) {
        console.error("No batchId provided");
        return;
      }

      console.log("batchId:", batchId);
      this.loading = true;
      analytics.track("Enterprise Report Generated", {
        batchId: this.generateBatchId,
      });
      this.generateBatchId = batchId;
      const {
        data: { generateClientReportFromBatchId },
      } = await this.$apollo.query({
        query: gql`
          query generateClientReportFromBatchId($batchId: ID!) {
            generateClientReportFromBatchId(batchId: $batchId)
          }
        `,
        variables: {
          batchId,
        },
      });

      const a = document.createElement("a");
      document.body.appendChild(a);
      a.setAttribute("style", "display:none");
      const blob = new Blob([generateClientReportFromBatchId], {
        type: "octet/stream",
      });
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = `batches_.csv`;
      a.click();
      window.URL.revokeObjectURL(url);

      this.loading = false;
    },
    async generatePublisherReportCSV(batchId) {
      if (!batchId) {
        console.error("No batchId provided");
        return;
      }

      console.log("batchId:", batchId);
      this.loading = true;
      analytics.track("Enterprise Report Generated", {
        batchId: this.generateBatchId,
      });
      this.generateBatchId = batchId;
      const {
        data: { generatePublisherReportFromBatchId },
      } = await this.$apollo.query({
        query: gql`
          query generatePublisherReportFromBatchId($batchId: ID!) {
            generatePublisherReportFromBatchId(batchId: $batchId)
          }
        `,
        variables: {
          batchId,
        },
      });

      const a = document.createElement("a");
      document.body.appendChild(a);
      a.setAttribute("style", "display:none");
      const blob = new Blob([generatePublisherReportFromBatchId], {
        type: "octet/stream",
      });
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = `batches_.csv`;
      a.click();
      window.URL.revokeObjectURL(url);

      this.loading = false;
    },

    async downloadCSV(batchId) {
      this.csvIsDownloading = true;
      await this.$moonpull.downloadSingleBatchCSV(batchId);
      this.csvIsDownloading = false;
    },

    toggleBin() {
      this.viewBin = !this.viewBin;
      this.page = 1;
    },
    handleClick(value) {
      console.log("Setting filter to:", value);
      this.selectedLinkFilter = value;
    },

    async toggleRow(batchId) {
      // ✅ Find the index of the batch in the original array (reactive-safe)
      const index = this.batches.items.findIndex((b) => b.id === batchId);
      if (index === -1) return;

      const batch = this.batches.items[index];
      const batchLinks = batch.numLinks;

      // ✅ Toggle dropdown row visibility
      this.$set(this.batches.items[index], "dropdownRow", !batch.dropdownRow);

      // ✅ Fetch cmpTypeCount only if first time opening
      if (batch.dropdownRow && batch.cmpTypeCount === undefined) {
        this.$set(this.batches.items[index], "cmpTypeCountLoading", true);

        const rawCount = await this.getCmpTypeCount(batch.id);

        this.$set(this.batches.items[index], "cmpTypeCount", rawCount);
        this.$set(this.batches.items[index], "cmpTypeCountLoading", false);
      }

      if (batch) {
        this.$set(batch, "dropdownToggle", !batch.dropdownToggle);
      }

      if (!batch.atlasId) {
        if (!batch.memoryCookieStatusCounts) {
          const {
            data: { memoryCookieStatusCounts },
          } = await this.$apollo.query({
            query: gql`
              query memoryCookieStatusCounts(
                $batchId: ID!
                $countPlatformResultsOnly: Boolean!
              ) {
                memoryCookieStatusCounts(
                  batchId: $batchId
                  countPlatformResultsOnly: $countPlatformResultsOnly
                ) {
                  status
                  statusReadable
                  count
                }
              }
            `,
            variables: {
              batchId,
              countPlatformResultsOnly: false,
            },
          });

          this.$set(
            this.batches.items[index],
            "memoryCookieStatusCounts",
            memoryCookieStatusCounts.filter(
              (status) => batchLinks > 1 || status.count > 0
            )
          );
        }
      } else {
        this.$set(batch, "memoryCookieStatusCounts", null);
      }
      if (batchLinks === 1 && (!batch.audits || batch.audits.length === 0)) {
        const {
          data: { batchById },
        } = await this.$apollo.query({
          query: gql`
            query GetBatchAudits($batchId: ID!) {
              batchById(id: $batchId) {
                audits {
                  advertiser {
                    name
                  }
                  countryCode
                  finalDomain
                  userDefinedMerchant
                }
              }
            }
          `,
          variables: { batchId },
        });
        this.$set(batch, "audits", batchById.audits);
      }
    },

    rerunBatch(id) {
      if (!id) {
        console.warn("No batch id provided to rerunBatch");
        return;
      }

      this.$moonpull.rerunBatch(id).then((success) => {
        if (success) {
          this.$router.go(0);
        }
      });
    },

    async getCmpTypeCount(batchId) {
      try {
        const { data } = await this.$apollo.query({
          query: gql`
            query($id: ID!) {
              batchById(id: $id) {
                cmpTypeCount {
                  name
                  counts {
                    cmpName
                    count
                  }
                }
              }
            }
          `,
          variables: { id: batchId },
          fetchPolicy: "no-cache",
        });
        const result =
          (data && data.batchById && data.batchById.cmpTypeCount) || [];
        return result;
      } catch (error) {
        console.error("Error fetching cmpTypeCount:", error);
        return [];
      }
    },
    toggleDropdown(batchId) {
      const batch = this.batches.items.find((batch) => batch.id === batchId);
      if (batch) {
        this.$set(batch, "dropdownToggle", !batch.dropdownToggle);
      }
    },

    async softDeleteBatch(batchId) {
      if (confirm("Are you sure you want to delete this batch?")) {
        this.deletingBatch = true;
        await this.$apollo.mutate({
          mutation: gql`
            mutation SoftDeleteBatch($batchId: ID!) {
              batchSoftDeleteById(id: $batchId) {
                id
              }
            }
          `,
          variables: {
            batchId,
          },
        });
        await this.$apollo.queries.batches.refetch();
        this.deletingBatch = false;
      }
    },

    async restoreBatch(batchId) {
      this.restoringBatch = true;
      await this.$apollo.mutate({
        mutation: gql`
          mutation RestoreBatchById($batchId: ID!) {
            batchRestoreById(id: $batchId)
          }
        `,
        variables: {
          batchId,
        },
      });
      this.restoringBatch = false;
      this.$apollo.queries.batches.refetch();
    },

    async renameBatch(batchId) {
      if (!this.newBatchName || this.newBatchName === "") {
        this.$store.dispatch("flashMessage", {
          type: "warning",
          msg: "Please provide a new name for the batch",
        });
        return;
      }
      this.innerModalLoading = true;
      await this.$apollo.mutate({
        mutation: gql`
          mutation($id: ID!, $record: BatchUpdateInput!) {
            batchUpdateById(id: $id, record: $record) {
              id
            }
          }
        `,
        variables: {
          id: batchId,
          record: {
            name: this.newBatchName,
            description: this.newBatchDescription,
          },
        },
      });
      this.innerModalLoading = false;
      this.newBatchName = "";
      this.$emit("dismissModals");
      this.$apollo.queries.batches.refetch();
    },

    async changeOwner(batchId) {
      if (!this.newBatchOwnerId) {
        this.$store.dispatch("flashMessage", {
          type: "warning",
          msg: "Please select a new owner for this batch",
        });
        return;
      }
      this.innerModalLoading = true;
      await this.$apollo.mutate({
        mutation: gql`
          mutation BatchChangeOwner(
            $batchId: ID!
            $newOwnerId: ID!
            $deleteComparisons: Boolean!
          ) {
            batchChangeOwner(
              batchId: $batchId
              newOwnerId: $newOwnerId
              deleteComparisons: $deleteComparisons
            )
          }
        `,
        variables: {
          batchId,
          newOwnerId: this.newBatchOwnerId,
          deleteComparisons: this.deleteComparisonsOnChangeOwner,
        },
      });
      this.newBatchOwnerId = null;
      this.innerModalLoading = false;
      this.deleteComparisonsOnChangeOwner = true;
      this.$emit("dismissModals");
      this.$apollo.queries.batches.refetch();
    },

    async markBatchAsComplete(batchId) {
      this.updatingBatch = true;
      await this.$apollo.mutate({
        mutation: gql`
          mutation BatchUpdateFinishedAtDate(
            $id: ID!
            $record: BatchUpdateInput!
          ) {
            batchUpdateById(record: $record, id: $id) {
              id
            }
          }
        `,
        variables: {
          id: batchId,
          record: {
            finishedAt: new Date(),
            status: "FORCE_DONE",
          },
        },
      });
      this.updatingBatch = false;
      this.$apollo.queries.batches.refetch();
    },

    async updateCsStatusAndComment(batch) {
      try {
        // Fetch the current user
        const user = this.$moonpull.getCurrentUserSession();
        const fullName = user?.name || "Unknown User";

        // Extract initials
        const initials = fullName
          .split(" ")
          .map((n) => n[0].toUpperCase())
          .join("");

        // Keep `csStatus` unchanged and store initials in the comment instead
        const updatedComment = batch.csComment
          ? `${batch.csComment} - ${initials}`
          : `- ${initials}`;

        await this.$apollo.mutate({
          mutation: gql`
            mutation UpdateBatchCsStatusAndComment(
              $id: ID!
              $csStatus: String
              $csComment: String
            ) {
              batchUpdateById(
                id: $id
                record: { csStatus: $csStatus, csComment: $csComment }
              ) {
                id
              }
            }
          `,
          variables: {
            id: batch.id,
            csStatus: batch.csStatus,
            csComment: updatedComment,
          },
        });
        this.$store.dispatch("flashMessage", {
          type: "success",
          msg: "CS Status and Comment updated successfully!",
        });
        this.$apollo.queries.batches.refetch();
      } catch (error) {
        console.error("Error updating CS Status and Comment:", error);
        this.$store.dispatch("flashMessage", {
          type: "error",
          msg: "Failed to update CS Status and Comment.",
        });
      }
    },

    async updateSupportResources(batchId) {
      try {
        const batch = this.batches.items.find((b) => b.id === batchId);

        if (!batch) {
          console.error(`Batch not found for ID: ${batchId}`);
          this.$store.dispatch("flashMessage", {
            type: "error",
            msg: "Could not find the batch to update.",
          });
          return;
        }

        await this.$apollo.mutate({
          mutation: gql`
            mutation UpdateSupportResources(
              $id: ID!
              $loomExternalUrl: String
              $loomInternalUrl: String
              $googleDocUrl: String
            ) {
              batchUpdateById(
                id: $id
                record: {
                  loomExternalUrl: $loomExternalUrl
                  loomInternalUrl: $loomInternalUrl
                  googleDocUrl: $googleDocUrl
                }
              ) {
                id
              }
            }
          `,
          variables: {
            id: batchId,
            loomExternalUrl: batch.loomExternalUrl || "",
            loomInternalUrl: batch.loomInternalUrl || "",
            googleDocUrl: batch.googleDocUrl || "",
          },
        });

        this.$store.dispatch("flashMessage", {
          type: "success",
          msg: "Support resources updated successfully!",
        });

        // Optionally refetch batches to reflect updates
        this.$apollo.queries.batches?.refetch?.();
      } catch (error) {
        console.error("Error updating support resources:", error);
        this.$store.dispatch("flashMessage", {
          type: "error",
          msg: "Failed to update support resources.",
        });
      }
    },

    yourAuditNavigation(batch) {
      if (!batch.audits || batch.audits.length === 0) {
        console.error("No audits found in the batch.");
        return;
      }

      const audit = batch.audits[0];
      if (audit) {
        const advertiserName =
          audit.advertiser?.name ||
          audit.finalDomain ||
          audit.userDefinedMerchant ||
          "Unknown Advertiser";
        const countryCode = audit.countryCode || "Unknown Country";

        if (!audit.advertiser || !audit.countryCode) {
          console.warn("Audit data is incomplete:", {
            advertiser: audit.advertiser,
            countryCode: audit.countryCode,
            audit,
          });
        }
        this.currentCountry = countryCode;
        this.filterString = advertiserName;

        this.$router.push({
          path: "/reporting/audits",
          query: {
            advertiser: advertiserName,
            country: countryCode,
            filter: advertiserName,
          },
        });
      } else {
        console.error("Audit object is null or undefined.");
      }
    },
  },

  beforeCreate() {
    analytics.page(" view", {
      path: window.location.hash,
      referrer: window.location.hash,
    });
  },

  async mounted() {
    if (!this.pageSize) {
      this.pageSize = 100;
    }
  },
});
</script>
